import PageableBase from 'app/collections/pageable_base';

export default PageableBase.extend({
  key: 'reports',
});



// WEBPACK FOOTER //
// ./app/collections/reports_base.js